import {useEffect, useState, useCallback} from 'react'
import {useSelector, useDispatch} from 'react-redux'
import * as Member from '../../store/ducks/member.duck'
import {Grid, Button, Dialog, DialogContent, DialogContentText, TextField, DialogTitle, Box, List, ListItem, ListItemIcon, ListItemText, ListSubheader} from '@mui/material'
import ReplyIcon from '@mui/icons-material/Reply'
import DownloadIcon from '@mui/icons-material/Download'
import Spinner from 'react-bootstrap/Spinner'
import {Card} from 'react-bootstrap'
import {saveAs} from 'file-saver'
import {styled} from '@mui/material/styles'
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp'
import MuiAccordion from '@mui/material/Accordion'
import MuiAccordionSummary from '@mui/material/AccordionSummary'
import MuiAccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import PolicyCard from '../Cards/PolicyCard'
// import Badge from '@mui/material/Badge'
import {useDropzone} from 'react-dropzone'
import FileUploadIcon from '@mui/icons-material/FileUploadOutlined'
import {Buffer} from 'buffer'

import {Formik, useFormikContext} from 'formik'
import * as Yup from 'yup'

// import {AnyObject} from 'yup'

const Accordion = styled((props) => <MuiAccordion disableGutters elevation={0} square {...props} />)(({theme, unread}) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  marginBottom: theme.spacing(2),
  backgroundColor: unread
    ? theme.palette.mode === 'dark'
      ? '#2a2a2a'
      : '#fffde7' // light yellow for unread
    : theme.palette.mode === 'dark'
    ? '#1e1e1e'
    : '#f9f9f9',
  '&::before': {
    display: 'none'
  }
}))

const AccordionSummary = styled((props) => <MuiAccordionSummary expandIcon={<ArrowForwardIosSharpIcon sx={{fontSize: '0.9rem'}} />} {...props} />)(({theme}) => ({
  backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, .05)' : 'rgba(0, 0, 0, .03)',
  flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)'
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(1)
  }
}))

const AccordionDetails = styled(MuiAccordionDetails)(({theme}) => ({
  padding: theme.spacing(2),
  borderTop: '1px solid rgba(0, 0, 0, .125)'
}))

export default function BillingMessages() {
  const [expanded, setExpanded] = useState(false)
  const [open, setOpen] = useState(false)
  const [processingOpen, setProcessingOpen] = useState(false)
  const returnStatus = useSelector((state) => state.member.ReturnStatus)
  const [downloadStatus, setDownloadStatus] = useState('Not Started')
  const [downloadFileName, setDownloadFileName] = useState('')
  const billingMessageDownload = useSelector((state) => state.member.BillingMessageDownload)
  const [activeReplyConversationId, setActiveReplyConversationId] = useState(null)
  const [downloadingAttachmentId, setDownloadingAttachmentId] = useState(null)

  //
  const dispatch = useDispatch()

  function allowMoreEditing() {
    // Close Submitting Modal
    setOpen(false)
    // Reactivate submit for another attempt
    // setIsLoading(false)
  }

  function finishEditing() {
    // Close All the Modal
    setProcessingOpen(false)
    setOpen(false)
    // setIsLoading(false)
  }

  // Fetch billing messages
  useEffect(() => {
    dispatch(Member.actions.fetchBillingMessages())
  }, [dispatch])

  // Map Incentives to Redux State
  const billingmessages = useSelector((state) => state.member.BillingMessages)

  function ReplyConversation(conversationId) {
    // Set the active reply message to open the reply form
    setActiveReplyConversationId(activeReplyConversationId === conversationId ? null : conversationId)
  }

  const handleClose = () => {
    setOpen(false)
  }

  function FormFiles() {
    const {setFieldValue, errors, values} = useFormikContext()
    const [myFiles, setMyFiles] = useState([])

    // If form is submitted and fails - re populate the files back into the dropzone
    if (values.attachment && values.attachment.length > 0 && myFiles && myFiles.length === 0) {
      setMyFiles(values.attachment)
    }
    //
    const fieldName = 'attachment'
    //

    const onDrop = useCallback(
      (acceptedFiles) => {
        setMyFiles([...myFiles, ...acceptedFiles])
        setFieldValue(fieldName, [...myFiles, ...acceptedFiles])
        console.log(myFiles)
      },
      [myFiles, setFieldValue, fieldName]
    )

    const {getRootProps, getInputProps} = useDropzone({
      accept: {
        'image/jpeg': [],
        'image/png': [],
        'image/jpg': [],
        'application/pdf': []
      },
      multiple: true,
      maxFiles: 20,
      maxFileSize: 6291457,
      onDrop
    })

    const removeFile = (file) => () => {
      const newFiles = [...myFiles]
      newFiles.splice(newFiles.indexOf(file), 1)
      setMyFiles(newFiles)
      setFieldValue(fieldName, [...newFiles])
    }

    const files = myFiles.map((file) => (
      <li key={file.path}>
        {file.path} - {file.size} bytes <button onClick={removeFile(file)}>Remove File</button>
      </li>
    ))
    return (
      <Grid item xs={12} md={12}>
        <section className='container px-0'>
          <div {...getRootProps({className: 'dropzone'})}>
            <input {...getInputProps()} />
            <FileUploadIcon color={'primary'} className={'mt-3 mb-3'} sx={{fontSize: 40}} />
            <p>Drop file here or Click to Upload from device</p>
            <p>(max size 6 MB)</p>
          </div>
          {files.length > 0 && (
            <aside>
              <h4>Files</h4>
              <ul>{files}</ul>
            </aside>
          )}
        </section>

        {errors[fieldName] ? <p className='error-help'>{errors[fieldName]}</p> : ''}
      </Grid>
    )
  }

  const downloadFile = (attachmentID, attachmentFilename, conversationId) => {
    // console.log(claim)
    if (downloadStatus === 'Not Started') {
      setDownloadingAttachmentId(attachmentID)
      dispatch(Member.actions.fetchBillingMessageDownload({attachmentId: attachmentID, conversationId: conversationId}))
      setDownloadFileName(attachmentFilename)
      setDownloadStatus('Fetching')
    }
  }

  // grab the blob from state and tell the browser to download
  const downloadBillingMessageFile = useCallback(() => {
    //   var exportDocName = `Project Schedule - ${header.name}`;
    if (billingMessageDownload && billingMessageDownload !== '') {
      const file = new Blob([Buffer.from(billingMessageDownload, 'base64')], {type: 'application/pdf'})
      saveAs(file, downloadFileName)
    }
  }, [downloadFileName, billingMessageDownload])

  // useEffect to fire when status is 'Fetching' and we get the result in redux
  useEffect(() => {
    if (downloadStatus === 'Fetching' && billingMessageDownload && billingMessageDownload !== '') {
      downloadBillingMessageFile()
      setDownloadingAttachmentId(null)
      setDownloadStatus('Not Started')
      dispatch(Member.actions.clearBillingMessageDownload())
    }
  }, [downloadStatus, downloadBillingMessageFile, billingMessageDownload, dispatch])

  function Savesubmit(data) {
    // Open Submitting modal
    setProcessingOpen(true)
    // Create structure to load file
    const formData = new FormData()
    // Add fields
    formData.append('id', data['id'])
    formData.append('msg', data['msg'])
    // Check if there are any files
    if (data['attachment'] && data['attachment'].length) {
      // Add files
      for (const fileUploadItem of data['attachment']) {
        formData.append('files', fileUploadItem)
      }
    }
    // Some debugging
    if (process.env.REACT_APP_DEBUG) {
      console.log(data)
    }
    // Save request/form
    dispatch(Member.actions.putBillingMessage({formData}))
  }

  const handleChange = (panelId) => (event, isExpanded) => {
    setExpanded(isExpanded ? panelId : false)
    if (isExpanded) {
      const conversation = billingmessages.find((c) => c.aggregateId === panelId)
      const hasUnreadMessages = conversation?.messages?.some((m) => !m.readDate)
      if (hasUnreadMessages) {
        dispatch(Member.actions.billingMessageRead({messageID: conversation.aggregateId}))
      }
    }
  }

  if (billingmessages && billingmessages.length > 0) {
    return (
      <>
        <PolicyCard title='Private Messages' cardClassname={'bg-white primary-border'} titleClassname='text-black pb-3'>
          <div className={'w-100'}>
            {billingmessages && billingmessages.length > 0 ? (
              billingmessages.map((conversation) => {
                const unreadCount = conversation.messages?.filter((msg) => !msg.readDate).length || 0
                return (
                  <Accordion expanded={expanded === conversation.aggregateId} onChange={handleChange(conversation.aggregateId)} key={conversation.aggregateId} unread={unreadCount > 0 ? 1 : 0}>
                    <AccordionSummary aria-controls={conversation.aggregateId} id={conversation.aggregateId}>
                      <Typography
                        sx={{
                          flexGrow: 1,
                          fontWeight: unreadCount > 0 ? 'bold' : 'normal',
                          color: unreadCount > 0 ? 'text.primary' : 'text.secondary'
                        }}
                      >
                        {conversation.subject} {unreadCount > 0 && <span style={{color: 'blue', fontWeight: 'bold', marginLeft: 10}}>New</span>}
                      </Typography>{' '}
                    </AccordionSummary>

                    <AccordionDetails>
                      {conversation.messages && conversation.messages.length > 0 ? (
                        conversation.messages.map((message) => {
                          const isUnread = !message.readDate
                          return (
                            <Card key={message.aggregateId} className={`mb-3 p-3 ${isUnread ? 'unread-message' : ''}`}>
                              <Typography variant='subtitle2' className='mb-1'>
                                From: {message.user?.displayName || message.author} — {message.sentDate && new Date(message.sentDate).toLocaleString()}
                                {isUnread && <span style={{color: 'blue', fontWeight: 'bold', marginLeft: 10}}>New</span>}
                              </Typography>

                              <Typography className='mb-2' style={{whiteSpace: 'pre-line'}}>
                                {message.message}
                              </Typography>

                              {message.attachments && message.attachments.length > 0 && (
                                <div className='mb-2'>
                                  <List
                                    dense
                                    subheader={
                                      <ListSubheader component='div' disableSticky sx={{pl: 0}}>
                                        Attachments
                                      </ListSubheader>
                                    }
                                  >
                                    {message.attachments.map((att) => (
                                      <ListItem key={att.attachmentId} disableGutters>
                                        <ListItemIcon>
                                          <DownloadIcon />
                                        </ListItemIcon>
                                        <ListItemText
                                          primary={
                                            <Button
                                              variant='text'
                                              size='small'
                                              onClick={() => downloadFile(att.attachmentId, att.fileName, conversation.aggregateId)}
                                              sx={{textTransform: 'none', padding: 0, minWidth: 0}}
                                            >
                                              {downloadingAttachmentId === att.attachmentId && downloadStatus === 'Fetching' ? `${att.fileName} (Downloading...)` : att.fileName}
                                            </Button>
                                          }
                                        />
                                      </ListItem>
                                    ))}
                                  </List>
                                </div>
                              )}
                            </Card>
                          )
                        })
                      ) : (
                        <Typography className='text-muted'>No messages in this conversation.</Typography>
                      )}
                      {/* Render reply form per conversation, not per message */}
                      {activeReplyConversationId === conversation.aggregateId ? (
                        <Formik
                          enableReinitialize
                          initialValues={{
                            id: conversation.aggregateId,
                            msg: '',
                            attachment: []
                          }}
                          validationSchema={Yup.object().shape({
                            msg: Yup.string().min(2, 'Too Short').max(5000, 'Too Long').required('Message is required')
                          })}
                          onSubmit={(values, actions) => {
                            Savesubmit(values)
                            actions.setSubmitting(false)
                            setActiveReplyConversationId(null)
                          }}
                        >
                          {({values, errors, touched, handleChange, handleSubmit}) => (
                            <form onSubmit={handleSubmit} style={{marginTop: 20}}>
                              <Grid container spacing={2}>
                                <Grid item xs={12}>
                                  <TextField
                                    label='Reply'
                                    name='msg'
                                    multiline
                                    rows={5}
                                    fullWidth
                                    value={values.msg}
                                    onChange={handleChange}
                                    error={touched.msg && Boolean(errors.msg)}
                                    helperText={touched.msg && errors.msg}
                                  />
                                </Grid>

                                <FormFiles />

                                <Grid item xs={12} textAlign='right'>
                                  <Button variant='text' onClick={() => setActiveReplyConversationId(null)} style={{marginRight: 10}}>
                                    Cancel
                                  </Button>
                                  <Button variant='contained' color='primary' type='submit'>
                                    Send
                                  </Button>
                                </Grid>
                              </Grid>
                            </form>
                          )}
                        </Formik>
                      ) : (
                        <div style={{textAlign: 'right'}}>
                          <Button variant='contained' startIcon={<ReplyIcon />} size='small' onClick={() => ReplyConversation(conversation.aggregateId)}>
                            Reply to Conversation
                          </Button>
                        </div>
                      )}
                    </AccordionDetails>
                  </Accordion>
                )
              })
            ) : (
              <Typography>No private messages available.</Typography>
            )}
          </div>
        </PolicyCard>

        <Dialog open={open} onClose={handleClose} aria-labelledby='Send Message' fullWidth={true} maxWidth='sm'>
          {processingOpen && (
            <>
              <DialogTitle>Submitting Message</DialogTitle>
              <DialogContent style={{paddingTop: 30, paddingBottom: 30}}>
                {/* Check for result of submitting message */}
                {returnStatus && returnStatus.length > 0 ? (
                  <>
                    {returnStatus === 'OK' ? (
                      <Card>
                        <Card.Body>
                          <div className='mb-2 bg-light-primary p-8 rounded self-stretch'>
                            <div className='text-primary'>
                              <strong>Message Sent</strong>
                            </div>
                          </div>
                        </Card.Body>
                        <Card.Body>
                          <Box component='div' sx={{display: {xs: 'none', md: 'block'}}}>
                            <Grid container xs={12} gap={3} justifyContent={'end'}>
                              <Button variant='contained' size={'large'} color='primary' disableElevation style={{background: '#0074A6'}} onClick={() => finishEditing()}>
                                Close
                              </Button>
                            </Grid>
                          </Box>

                          <Box component='div' sx={{display: {xs: 'block', md: 'none'}}}>
                            <Grid container xs={12} justifyContent={'space-between'}>
                              <Grid item className={'pr-2'} xs={6}>
                                <Button variant='contained' size={'large'} className={'w-100'} color='primary' disableElevation style={{background: '#0074A6'}} onClick={() => finishEditing()}>
                                  Close
                                </Button>
                              </Grid>
                            </Grid>
                          </Box>
                        </Card.Body>
                      </Card>
                    ) : (
                      <Card>
                        <Card.Body>
                          <div className='mb-2 bg-light-danger p-8 rounded self-stretch'>
                            <div className='text-danger'>
                              <strong>{returnStatus}</strong>
                            </div>
                          </div>
                        </Card.Body>
                        <Card.Body>
                          <Box component='div' sx={{display: {xs: 'none', md: 'block'}}}>
                            <Grid container xs={12} gap={3} justifyContent={'end'}>
                              <Button variant='contained' size={'large'} style={{background: '#E6F5FF', color: '#0074A6'}} disableElevation onClick={() => finishEditing()}>
                                Cancel
                              </Button>
                              <Button variant='contained' size={'large'} color='primary' type='submit' disableElevation style={{background: '#0074A6'}} onClick={() => allowMoreEditing()}>
                                Edit and Resubmit
                              </Button>
                            </Grid>
                          </Box>

                          <Box component='div' sx={{display: {xs: 'block', md: 'none'}}}>
                            <Grid container xs={12} justifyContent={'space-between'}>
                              <Grid item className={'pr-2'} xs={6}>
                                <Button variant='contained' size={'large'} className={'w-100'} style={{background: '#E6F5FF', color: '#0074A6'}} disableElevation onClick={() => handleClose()}>
                                  Return to Home
                                </Button>
                              </Grid>
                              <Grid item className={'pl-2'} xs={6}>
                                <Button variant='contained' size={'large'} className={'w-100'} color='primary' disableElevation style={{background: '#0074A6'}} onClick={() => allowMoreEditing()}>
                                  Edit and Resubmit
                                </Button>
                              </Grid>
                            </Grid>
                          </Box>
                        </Card.Body>
                      </Card>
                    )}
                  </>
                ) : (
                  <DialogContentText>
                    <span className='indicator-progress' style={{display: 'block'}}>
                      Please wait while we process your submission... <Spinner animation='border' className='bc-sync-spinner' size='sm' variant='light' />
                    </span>
                  </DialogContentText>
                )}
              </DialogContent>
            </>
          )}
        </Dialog>
      </>
    )
  } else {
    return null
  }
}

// <FormFiles />
